// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Block4_wrapper__1FmZx"};